import {SET_SUB_SUB_CATEGORIES} from '../actionTypes';
import {IFarmInputProductSubSubCategory} from 'constants/interfaces';

export type SubSubCategoryState = {
  lastUpdate: number;
  subSubCategories: IFarmInputProductSubSubCategory[];
};
const initialState: SubSubCategoryState = {lastUpdate: 0, subSubCategories: []};

export default function (
  state = initialState,
  action: {type: string; payload: any},
) {
  switch (action.type) {
    case SET_SUB_SUB_CATEGORIES: {
      const subSubCategories: IFarmInputProductSubSubCategory[] =
        action.payload || [];
      const stateUpdate: SubSubCategoryState = {
        lastUpdate: new Date().getTime(),
        subSubCategories: subSubCategories.map((category) => ({...category})),
      };
      return stateUpdate;
    }

    default:
      return state;
  }
}
